import React from "react";
import { Col, Row } from "react-bootstrap";

import img1 from "../../Assets/img1.png";
import img2 from "../../Assets/img2.png";
import img3 from "../../Assets/img3.png";
import img4 from "../../Assets/img4.jpg";
import img5 from "../../Assets/img5.jpg";
import img6 from "../../Assets/img6.jpg";
import img7 from "../../Assets/img7.jpg";
import img8 from "../../Assets/img8.jpg";
import img9 from "../../Assets/img9.jpg";
import img10 from "../../Assets/img10.jpg";
import img11 from "../../Assets/img11.jpg";
import img12 from "../../Assets/img12.jpg";
import img13 from "../../Assets/img13.jpg";
import img14 from "../../Assets/img14.jpg";
import img15 from "../../Assets/img15.jpg";


function Gallery() {
  const images = [
    { src: img1, title: "Formal Presentation" },
    { src: img2, title: "In social gathering" },
    { src: img3, title: "Celebrating independence day" },
    { src: img4, title: "Post representation at national competition" },
    { src: img5, title: "Receiving appreciation token at conference" },
    { src: img7, title: "Farewell with students" },
    { src: img8, title: "International conference on social issues" },
    { src: img9, title: "Meeting with head of the department" },
    { src: img10, title: "Sports activity" },
    { src: img11, title: "Blood donation campaign" },
    { src: img13, title: "Tour to historical places" },
    { src: img6, title: "Tour with a foreigner guest" },
    { src: img12, title: "University convocation" },
    { src: img14, title: "Early morning at college" },
    { src: img15, title: "Fishing at creek" },

  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {images.map((img, index) => (
        <Col key={index} xs={6} md={3} className="gallery-item">
          <img
            src={img.src}
            alt={img.title}
            className="img-fluid gallery-image"
          />
          <div className="gallery-text">{img.title}</div>
        </Col>
      ))}
    </Row>
  );
}

export default Gallery;